// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-alert[data-v-24f988ea]{padding-top:0;padding-bottom:0;margin-bottom:0;margin-top:.5em}.v-chip.v-size--small[data-v-24f988ea]{border-radius:4px;font-size:10px;padding:2px 4px}.v-chip.on-error[data-v-24f988ea]{height:50px}.v-chip[data-v-24f988ea]{line-height:12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
